import {
  HttpContextToken,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../../features/login/services/auth';
import { AuthActions } from '../../state/auth/auth.actions';
import { Router } from '@angular/router';
import { principalRouteNavigate } from '../../shared/utilities/const/route';
import { SettingActions } from '../../state/settings/setting.actions';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const store = inject(Store);
  const authService = inject(AuthService);
  const router = inject(Router);

  // INSERISCO I COOKIE IN TUTTE LE CHIAMATE PER IL BE
  const clonedRequest = req.clone({
    withCredentials: true,
  });
  let shouldShowToast = !clonedRequest.context.get(SKIP_ERROR_TOAST);
  const isRefreshAttempt = clonedRequest.url.includes('refresh');
  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('[ERROR INTERCEPTOR]', error);

      const errorMessage = error.error?.message || error.message || 'Errore sconosciuto.';
      let toastMessage = errorMessage;

      // Gestione centralizzata degli errori
      switch (error.status) {
        case 400:
          console.log('Richiesta non valida');
          toastMessage = 'Richiesta non valida';
          break;
        case 401:
          // CATTURO EVENTUALI ERRORI DELLE CHIAMATE HTTP COME L'ERROR INTERCEPTOR
          // SE L'ERRORE E' 401 TENTO DI CHIAMARE IL REFRESH SESSION
          if (!clonedRequest.url.includes('refresh')) {
            console.warn('[AUTH INTERCEPTOR] 401 → Tentativo di refresh sessione...');
            return authService.refreshSession().pipe(
              switchMap(() => {
                console.log('[AUTH INTERCEPTOR] Refresh riuscito, riprovo la richiesta originale.');
                // SE LA CHIAMATA DI REFRESH E' ANDATA BENE ALLORA PROCEDO CON IL NEXT DELLE CHIAMATE
                return next(clonedRequest);
              }),
              // SE LA CHIAMATA DI REFRESH E' ANDATA IN ERRORE ALLORA EFFETTUO IL LOGOUT
              catchError((refreshError: HttpErrorResponse) => {
                const refreshMessage =
                  refreshError.error?.message ||
                  refreshError.message ||
                  "Sessione scaduta. Effettua nuovamente l'accesso.";

                console.error('[AUTH INTERCEPTOR] Refresh fallito, eseguo logout.');
                store.dispatch(AuthActions.logout({ spid: false }));
                if (shouldShowToast && authService.hasLoggedOnce) {
                  store.dispatch(
                    SettingActions.openAlert({
                      duration: 6000,
                      message: refreshMessage,
                      variant: 'error',
                    }),
                  );
                  authService.hasLoggedOnce = false; // Resetto il flag per evitare di mostrare il toast più volte
                }
                store.dispatch(SettingActions.closeSpinner());
                return throwError(() => new Error(refreshMessage));
              }),
            );
          } else {
            console.error('[AUTH INTERCEPTOR] Refresh fallito, eseguo logout.');
            store.dispatch(AuthActions.logout({ spid: false }));
            toastMessage = "Sessione scaduta. Effettua nuovamente l'accesso.";
            shouldShowToast = authService.hasLoggedOnce;
          }
          break;
        case 404:
          console.log('Risorsa non trovata');
          toastMessage = 'Risorsa non trovata';
          break;
        case 500:
          console.log('Errore interno del server');
          toastMessage = 'Errore interno del server';
          break;
        case 503:
          toastMessage = 'Servizio temporaneamente non disponibile';
          router.navigateByUrl(principalRouteNavigate.serverUnavailable);
          break;
        default:
          console.log(errorMessage);
      }

      if (shouldShowToast) {
        if (isRefreshAttempt) authService.hasLoggedOnce = false; // Resetto il flag per evitare di mostrare il toast più volte
        store.dispatch(
          SettingActions.openAlert({
            duration: 6000,
            message: toastMessage,
            variant: 'error',
          }),
        );
      }
      store.dispatch(SettingActions.closeSpinner());
      return throwError(() => new Error(toastMessage));
    }),
  );
}
